<template>
	<v-container fluid class="pa-6 ma-0 w-100">
		<v-alert type="info" variant="tonal" border="start" class="next-ui-banner">
			<template #title>New Workbench UI (FACT-5827+)</template>
			Served because <code>WORKBENCH_NEW_UI</code> is enabled. This placeholder is
			here to prove the feature-flag switch (FACT-5963) renders the alternate path —
			the real tabbed Policy/Locations workbench lands with FACT-5827 and replaces
			this component entirely.
		</v-alert>
	</v-container>
</template>

<script setup lang="ts"></script>

